import React from "react";
import "./SolutionsSection.css";
import { Link } from "react-router-dom";

const solutions = [
  {
    title: "Case Management Platform",
    description: "Track progress, deadlines, and milestones",
  },
  {
    title: "Lead Management",
    description: "Manage potential client leads effectively",
  },
  {
    title: "Document Management",
    description: "Organize and access legal documents with ease",
  },
  {
    title: "Contract Management",
    description: "Streamline contract creation and approvals",
  },
  {
    title: "Business Analytics",
    description: "Gain actionable insights for better decision-making",
  },
  {
    title: "eSignatures",
    description: "Secure digital signing for faster transactions",
  },
  {
    title: "Time, Billing & Payments",
    description: "Track billable hours and manage payments",
  },
  {
    title: "Document Assembly",
    description: "Automate document creation for efficiency",
  },
];

const SolutionsSection = () => {
  return (
    <section className="solutions-section">
      <div className="solutions-header">
        <h2>
          Accelerate your legal practice <br />
          with AI-powered legal technology
        </h2>
        <div className="solutions-subtext">
          <span className="highlight">Our solutions include:</span>
          <p>
            At Nobel AI Legal, we provide powerful tools designed to help
            Personal Injury Lawyers work faster and smarter.
          </p>
        </div>
      </div>
      <div className="solutions-grid">
        <div className="solution-row">
          {solutions.slice(0, 3).map((item, index) => (
            <div className="solution-card" key={index}>
              <img
                src={
                  "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/UXks7sCBKzljAT69qmhD/media/4f14405c-d5af-47f6-8cf9-a1423fa65da8.png"
                }
                alt="scale icon"
                className="solution-icon"
              />
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <Link to="/contact" className="solution-link-button">
                Schedule a demo
              </Link>
            </div>
          ))}
        </div>

        <div className="solution-row">
          {solutions.slice(3, 6).map((item, index) => (
            <div className="solution-card" key={index + 3}>
              <img
                src={
                  "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/UXks7sCBKzljAT69qmhD/media/4f14405c-d5af-47f6-8cf9-a1423fa65da8.png"
                }
                alt="scale icon"
                className="solution-icon"
              />
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <Link to="/contact" className="solution-link-button">
                Schedule a demo
              </Link>
            </div>
          ))}
        </div>

        <div className="solution-row">
          {solutions.slice(6, 8).map((item, index) => (
            <div className="solution-card" key={index + 6}>
              <img
                src={
                  "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/UXks7sCBKzljAT69qmhD/media/4f14405c-d5af-47f6-8cf9-a1423fa65da8.png"
                }
                alt="scale icon"
                className="solution-icon"
              />
              <h3>{item.title}</h3>
              <p>{item.description}</p>
              <Link to="/contact" className="solution-link-button">
                Schedule a demo
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;
